export default __webpack_public_path__ + "static/media/share.2b73d5ef.jpg";